// extracted by mini-css-extract-plugin
export default {"productGallery":"aK-z","inQuickShop":"bK-z"};